
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'pme-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoadingComponent implements OnInit{

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef <LoadingComponent>
  ) {}

  currentFrame: number = 0;
  totalFrames: number = 6;
  currentMessage: number = 0;
  totalMessages: number = 3;

  ngOnInit(): void {
    this.startAnimation();
  }

  startAnimation(): void {
    setInterval(() => {
      this.currentFrame = (this.currentFrame + 1) % this.totalFrames;

    }, 300);

    setInterval(() => {
      this.currentMessage = (this.currentMessage + 1) % this.totalMessages;
    }, 7000);
  }

}


